// extracted by mini-css-extract-plugin
export var copyIcon = "_sb-2";
export var discountCard = "_sb-0";
export var discountCode = "_sb-3";
export var discountContent = "_sb-1";
export var loadingCard = "_sb-4";